(function directoryModule(scope) {
  'use strict';
  function normalize(value) {
    return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/([a-z])(\d)/g, '$1 $2').replace(/(\d)([a-z])/g, '$1 $2').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function initialize(document) {
    document.querySelectorAll('[data-directory]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const input = root.querySelector('[data-directory-filter]');
      const links = [...root.querySelectorAll('[data-model-link]')];
      const indexed = links.map((link) => ({ link, tokens: normalize(link.dataset.search).split(' ') }));
      const groups = [...root.querySelectorAll('[data-brand-group]')];
      // Keep these native disclosures out of the theme's global animated Accordion handler.
      groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
        event.stopImmediatePropagation();
      }, { capture: true }));
      let openBeforeSearch = null;
      input.addEventListener('input', () => {
        const words = normalize(input.value).split(' ').filter(Boolean);
        if (words.length && openBeforeSearch === null) openBeforeSearch = groups.map(group => group.open);
        let count = 0;
        indexed.forEach(({ link, tokens }) => {
          link.hidden = !words.every((word) => tokens.some(token => token === word || (/^[a-z]{2,}$/.test(word) && token.startsWith(word))));
          if (!link.hidden) count++;
        });
        groups.forEach((group, index) => {
          const visible = [...group.querySelectorAll('[data-model-link]')].filter(link => !link.hidden).length;
          group.hidden = visible === 0;
          group.querySelector('[data-brand-count]').textContent = `${visible} ${visible === 1 ? 'smartwatch' : 'smartwatches'}`;
          if (words.length) group.open = visible > 0;
          else if (openBeforeSearch) group.open = openBeforeSearch[index];
        });
        if (!words.length) openBeforeSearch = null;
        root.querySelector('[data-directory-count]').textContent = `${count} of ${links.length} ${groups.length ? 'smartwatches' : 'records'}`;
        root.querySelector('[data-directory-empty]').hidden = count > 0;
      });
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { initialize };
  if (scope.document) initialize(scope.document);
}(typeof globalThis !== 'undefined' ? globalThis : this));
